import script from "./base-datagrid.vue?vue&type=script&lang=js"
export * from "./base-datagrid.vue?vue&type=script&lang=js"

import "./base-datagrid.vue?vue&type=style&index=0&id=e5f56da0&lang=scss"

const __exports__ = script;

export default __exports__